import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Button, Column, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useOptimizedMobileViewport } from '~/providers/MobileViewportWidthProvider';
import styles from './NativeFullScreenLayout.module.scss';
export const GetNativeFullScreenLayoutTID = (parentTestId)=>getTestIds(parentTestId);
export const NativeFullScreenLayout = (param)=>{
    let { title, body, caption, action, testId } = param;
    const { NativeFullScreenLayoutTestIds } = useMemo(()=>GetNativeFullScreenLayoutTID(testId), [
        testId
    ]);
    // WHY: full-screen boot surface that can render outside the router (pre-mount bootstrap), so opt into the device-width viewport — the app default is 1280, which iOS honors → tiny.
    useOptimizedMobileViewport(true);
    return /*#__PURE__*/ _jsx(Box, {
        testId: NativeFullScreenLayoutTestIds.Root(),
        className: styles.root,
        children: /*#__PURE__*/ _jsxs(Column, {
            gap: 24,
            alignItems: "center",
            width: 360,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    testId: NativeFullScreenLayoutTestIds.Title(),
                    variant: "h3",
                    children: title
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    testId: NativeFullScreenLayoutTestIds.Body(),
                    variant: "paragraph1",
                    children: body
                }),
                caption != null && /*#__PURE__*/ _jsx(Typography, {
                    testId: NativeFullScreenLayoutTestIds.Caption(),
                    variant: "paragraph2",
                    skin: "secondary",
                    children: caption
                }),
                /*#__PURE__*/ _jsx(Button, {
                    testId: NativeFullScreenLayoutTestIds.Action(),
                    onClick: action.onClick,
                    bi: {
                        name: action.biName
                    },
                    children: action.label
                })
            ]
        })
    });
};
